/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { MockCondition } from "./MockCondition";
import { MockResponse } from "./MockResponse";
import { MockScripting } from "./MockScripting";
import * as t from "io-ts";

/**
 * The rule a passed request can follow in order to obtain the defined mocked response.
 */

// required attributes
const MockRuleR = t.interface({
  tags: t.readonlyArray(t.string, "array of string"),

  conditions: t.readonlyArray(MockCondition, "array of MockCondition"),

  is_active: t.boolean,

  name: t.string,

  order: t.Integer,

  response: MockResponse
});

// optional attributes
const MockRuleO = t.partial({
  id: t.string,

  scripting: MockScripting
});

export const MockRule = t.intersection([MockRuleR, MockRuleO], "MockRule");

export type MockRule = t.TypeOf<typeof MockRule>;
